import styled from "styled-components";
import Button from "./Button";

const StyledCommentMenuButton = styled(Button)`
  background-color: #fff;
  border: none;
  cursor: pointer;
`;

export default StyledCommentMenuButton;
